import { useState } from 'react';
import axios from 'axios';

import { useSysconfig } from '~/components/SystemConfiguration/SystemConfigurationScreen';
import useDataFetcher from '~/components/useDataFetcher';
import type { ESignConfigResponse } from '~/server_shared/openapi/data-contracts';
import { reportAxiosError } from '~/Utils';

export const useESignConfiguration = () => {
  // @ts-expect-error TODO: useSysconfig hook needs TypeScript definition
  const { organization } = useSysconfig();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const baseRoute = `/sysconfig/api/v1/organizations/${organization.id}/e_sign/config`;

  const { isLoading, isError, data: configuration, reloadData } = useDataFetcher<ESignConfigResponse | null>(baseRoute);

  const createConfiguration = async () => {
    try {
      setIsSubmitting(true);
      await axios.post<ESignConfigResponse>(baseRoute, {
        vendor_type: 'dropbox_sign',
        vendor_config: {},
        is_enabled: true,
      });
      await reloadData();
    } catch (error) {
      await reportAxiosError(error);
      throw error;
    } finally {
      setIsSubmitting(false);
    }
  };

  const updateConfiguration = async (is_enabled: boolean) => {
    try {
      setIsSubmitting(true);
      await axios.put<ESignConfigResponse>(baseRoute, { is_enabled });
      await reloadData();
    } catch (error) {
      await reportAxiosError(error);
      throw error;
    } finally {
      setIsSubmitting(false);
    }
  };

  return {
    isLoading,
    isError,
    configuration,
    isSubmitting,
    hasConfiguration: !!configuration?.id,
    isESignEnabled: !!configuration?.id && !!configuration?.is_enabled,
    createConfiguration,
    updateConfiguration,
  };
};
